var t={input:"styles_input__WNpfS"};export{t as default};
